import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GigiNews').create(() => ({
  root: {
    position: 'relative',
    width: '90%',
    overflow: 'hidden',
    height: '120px',
    borderRadius: '12px',
    boxShadow: '2px 0px 10px 0px rgba(0, 0, 0, 0.20)',
    backgroundSize: '102%',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    p: {
      margin: 0,
      cursor: 'pointer',
      pointerEvents: 'none',
    },
  },
}))
